import React from 'react';
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';

// Components
import ToolbarTool from '../../../../workspace/toolbar/components/ToolbarTool';
import Icon from '../../../../components/icons/Icon';

// Utils
import { isSelectingSingleSelectionAndCell } from '../../bridge/utils/selectionUtils/tableSelectionPredicateUtils';
import { addHotTableFormulaToCell } from '../utils/hotInstanceUtils/cell/hotTableCellFormulaUtils';

// Selectors
import { useActiveTableCallback, useActiveTableSelector } from '../../bridge/store/hotTableStoreHooks';
import { selectActiveTableCellSelection } from '../../bridge/store/selectors/activeHotTableCellSelectionSelectors';

type TableCellFormulaToolProps = Record<string, unknown> & {
    element?: ImMNElement;
};

const TableCellFormulaTool: React.FC<TableCellFormulaToolProps> = (props) => {
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    const triggerFormula = useActiveTableCallback((activeTable) => addHotTableFormulaToCell(activeTable.instance), []);

    return (
        <div className="TableCellFormulaTool">
            <ToolbarTool
                {...props}
                onClick={triggerFormula}
                isActive={false}
                disabled={!isSelectingSingleSelectionAndCell(currentCellSelections)}
                preventFocusChange
            >
                <Icon name="toolbar-formula" />
            </ToolbarTool>
        </div>
    );
};

export default TableCellFormulaTool;
